const DASHBOARD_THEME_COLOR_STORAGE_KEY = "renda-dashboard-theme-color";
const DASHBOARD_THEME_COLOR_VAR = "--base-500";
const DEFAULT_DASHBOARD_THEME_COLOR = "#6aa9ff";

export const getDashboardThemeColor = (): string => {
  if (!isBrowser()) {
    return DEFAULT_DASHBOARD_THEME_COLOR;
  }

  const rawColor = getComputedStyle(document.documentElement)
    .getPropertyValue(DASHBOARD_THEME_COLOR_VAR)
    .trim();

  return normalizeHexColor(rawColor) ?? DEFAULT_DASHBOARD_THEME_COLOR;
};

export const applyDashboardThemeColor = (color: string): string => {
  const normalizedColor =
    normalizeHexColor(color) ?? DEFAULT_DASHBOARD_THEME_COLOR;

  if (!isBrowser()) {
    return normalizedColor;
  }

  document.documentElement.style.setProperty(
    DASHBOARD_THEME_COLOR_VAR,
    normalizedColor,
  );
  window.localStorage.setItem(
    DASHBOARD_THEME_COLOR_STORAGE_KEY,
    normalizedColor,
  );

  return normalizedColor;
};

export const resetDashboardThemeColor = (): string => {
  if (!isBrowser()) {
    return DEFAULT_DASHBOARD_THEME_COLOR;
  }

  document.documentElement.style.removeProperty(DASHBOARD_THEME_COLOR_VAR);
  window.localStorage.removeItem(DASHBOARD_THEME_COLOR_STORAGE_KEY);

  return getDashboardThemeColor();
};

export const applyStoredDashboardThemeColor = (): void => {
  if (!isBrowser()) {
    return;
  }

  const storedColor = window.localStorage.getItem(
    DASHBOARD_THEME_COLOR_STORAGE_KEY,
  );

  if (!storedColor) {
    return;
  }

  const normalizedColor = normalizeHexColor(storedColor);

  if (!normalizedColor) {
    window.localStorage.removeItem(DASHBOARD_THEME_COLOR_STORAGE_KEY);
    return;
  }

  document.documentElement.style.setProperty(
    DASHBOARD_THEME_COLOR_VAR,
    normalizedColor,
  );
};

const normalizeHexColor = (color: string): string | null => {
  const trimmedColor = color.trim();

  if (/^#[\da-f]{6}$/i.test(trimmedColor)) {
    return trimmedColor.toLowerCase();
  }

  const shortHexMatch = trimmedColor.match(/^#([\da-f]{3})$/i);

  if (!shortHexMatch) {
    return null;
  }

  const shortHex = shortHexMatch[1];

  if (!shortHex) {
    return null;
  }

  return `#${shortHex
    .split("")
    .map((char) => `${char}${char}`)
    .join("")
    .toLowerCase()}`;
};

const isBrowser = () =>
  typeof window !== "undefined" && typeof document !== "undefined";
